<template>
    <b-tab title-link-class="p-0">
        <template v-slot:title>
            <b-nav-item-dropdown no-flip name="tab-payments">
                <template slot="button-content">
                    <i class="cus-money"></i>
                    Payments
                </template>
                <div>
                    <b-dropdown-item @click="displayList()">
                        <i class="cus-money"></i>
                        View Payments
                    </b-dropdown-item>
                </div>

                <li
                    v-if="_hasAccess('billing.payment.create')"
                    class="dropdown-divider"
                ></li>

                <b-dropdown-item
                    v-if="_hasAccess('billing.payment.create')"
                    @click="createPayment"
                >
                    <i class="cus-add"></i>
                    New Payment
                </b-dropdown-item>
            </b-nav-item-dropdown>
        </template>
        <b-card-text>
            <payment-list ref="paymentList" :key="keyview" />
        </b-card-text>
    </b-tab>
</template>

<script>
import PaymentList from "@/components/billing-payment/payment-list";

export default {
    components: {
        PaymentList
    },
    data() {
        return {
            keyview: 0
        };
    },
    methods: {
        displayList() {
            this.keyview += 1;
        },
        reloadPayments() {
            // Render getPayments when the paymentList already rendered
            if (this.$refs.paymentList) {
                this.$refs.paymentList.getPayments();
            }
        },
        createPayment() {
            this.$emit("create-payment");
        }
    }
};
</script>
